import { useState } from "react";
import { useCases } from "./useCases";
import { SectionHead } from "./SectionHead";
import { Reveal } from "./Reveal";
import { CompareSlider } from "./CompareSlider";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const BeforeAfter = () => {
  const cases = useCases();
  const [active, setActive] = useState(0);
  if (!cases.length) return null;
  const c = cases[Math.min(active, cases.length - 1)];

  return (
    <section id="risultati" className="relative py-28 sm:py-40 bg-[#F4F3EC]" data-testid="before-after-section">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <SectionHead
          eyebrow="Casi reali"
          lines={["Gengive che tornano", <em key="e" className="text-[#3E6B48]">a respirare.</em>]}
          intro="Trascina il cursore per confrontare le gengive prima e dopo la terapia laser. Ogni caso è pubblicato con il consenso scritto del paziente."
        />
        <div className="mt-16 grid lg:grid-cols-12 gap-8 items-start">
          <Reveal className="lg:col-span-8">
            <CompareSlider key={c.id} before={`${BACKEND}${c.before_url}`} after={`${BACKEND}${c.after_url}`} title={c.title} />
          </Reveal>
          <Reveal className="lg:col-span-4" delay={0.15}>
            <p className="eyebrow text-[#3E6B48]">Caso {Math.min(active, cases.length - 1) + 1} di {cases.length}</p>
            <h3 className="f-serif text-4xl text-[#1B3B28] leading-[1.05] mt-3" data-testid="before-after-title">{c.title}</h3>
            {c.description && <p className="text-[#526356] mt-4 leading-relaxed" data-testid="before-after-description">{c.description}</p>}
            {cases.length > 1 && (
              <div className="mt-8 grid grid-cols-3 gap-3">
                {cases.map((x, i) => (
                  <button key={x.id} onClick={() => setActive(i)} data-testid={`before-after-thumb-${i}`}
                    className={`aspect-square rounded-2xl overflow-hidden ring-2 transition-[box-shadow,opacity] ${i === active ? "ring-[#3E6B48]" : "ring-transparent opacity-60 hover:opacity-100"}`}>
                    <img src={`${BACKEND}${x.after_url}`} alt={x.title} className="w-full h-full object-cover" loading="lazy" />
                  </button>
                ))}
              </div>
            )}
            <p className="text-xs text-[#526356] mt-8">I risultati variano da persona a persona e dipendono dalla situazione di partenza e dal mantenimento.</p>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
